<template>
  <!-- 查询记录 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="bread">查询记录</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="content">
        <div class="title">查询记录</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 精选运价 -->
          <el-tab-pane label="精选运价" name="first">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input
                v-model="jxycForm.query_number"
                placeholder="查询编号"
              ></el-input>
              <el-select v-model="jxycForm.state_port_id" placeholder="起运港">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn + '-' + item.name_en"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select v-model="jxycForm.end_port_id" placeholder="目的港" filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="mdgActiveName">
                  <el-tab-pane
                    :key="index"
                    v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                      :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist"
                    >
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                        :key="adx"
                        :label="at.port_name + '-' + at.name_en"
                        :value="at.port_id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="jxycdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi('jxyj')">重置</el-button>
                <el-button class="shaixuan" @click="jxycSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="jxycTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="query_number" label="查询编号">
              </el-table-column>
              <el-table-column prop="state_port_name" label="起运港">
              </el-table-column>
              <el-table-column prop="end_port_name" label="目的港">
              </el-table-column>
              <el-table-column prop="cases_gauge_type" label="箱型">
              </el-table-column>
              <el-table-column prop="ymd" label="查询时间">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="jxycForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="jxycForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="jxycTotal"
            >
            </el-pagination>
          </el-tab-pane>
          <!-- 现舱市场 -->
          <el-tab-pane label="现舱市场" name="second">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input
                v-model="xcscForm.query_number"
                placeholder="查询编号"
              ></el-input>
              <el-select v-model="xcscForm.state_port_id" placeholder="起运港">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn + '-' + item.name_en"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select v-model="xcscForm.end_port_id" placeholder="目的港" filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="mdgActiveName">
                  <el-tab-pane
                    :key="index"
                    v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                      :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist"
                    >
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                        :key="adx"
                        :label="at.port_name + '-' + at.name_en"
                        :value="at.port_id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="xcscdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi('xcsc')">重置</el-button>
                <el-button class="shaixuan" @click="xcscSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="xcscTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="query_number" label="查询编号">
              </el-table-column>
              <el-table-column prop="state_port_name" label="起运港">
              </el-table-column>
              <el-table-column prop="end_port_name" label="目的港">
              </el-table-column>
              <el-table-column prop="cases_gauge_type" label="箱型">
              </el-table-column>
              <el-table-column prop="ymd" label="查询时间">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="xcscForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="xcscForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="xcscTotal"
            >
            </el-pagination>
          </el-tab-pane>
          <!-- 船东SPOT -->
          <el-tab-pane label="船东SPOT" name="third">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input v-model="cdForm.query_number" placeholder="查询编号"></el-input>
              <el-select v-model="cdForm.state_port_id" placeholder="起运港">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn + '-' + item.name_en"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select v-model="cdForm.end_port_id" placeholder="目的港" filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="mdgActiveName">
                  <el-tab-pane
                    :key="index"
                    v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                      :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist"
                    >
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                        :key="adx"
                        :label="at.port_name + '-' + at.name_en"
                        :value="at.port_id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="cddate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi('cd')">重置</el-button>
                <el-button class="shaixuan" @click="cdSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="cdTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="query_number" label="查询编号">
              </el-table-column>
              <el-table-column prop="state_port_name" label="起运港">
              </el-table-column>
              <el-table-column prop="end_port_name" label="目的港">
              </el-table-column>
              <el-table-column prop="cases_gauge_type" label="箱型">
              </el-table-column>
              <el-table-column prop="ymd" label="查询时间">
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="cdForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="cdForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="cdTotal"
            >
            </el-pagination>
          </el-tab-pane>
          <!-- 美加到门 -->
          <el-tab-pane label="美加到门" name="fourth">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input v-model="mjdmForm.query_number" placeholder="查询编号"></el-input>
              <el-select
                v-model="mjdmForm.country_id"
                clearable
                placeholder="国家"
                @change="qiehuan"
              >
                <el-option label="美国" value="6"></el-option>
                <el-option label="加拿大" value="7"></el-option>
              </el-select>
              <el-select
                @change="getfujinPort"
                v-model="mjdmForm.end_city_id"
                clearable
                filterable
                placeholder="送达城市(邮编) | 起运城市(邮编)"
                remote
                reserve-keyword
                :remote-method="zipCodeRemoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in endPortList"
                  :key="item.id"
                  :label="item.place_name + '(' + item.postal_code + ')'"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="mjdmForm.port_id"
                clearable
                filterable
                placeholder="卸货港、卸货地 | 装货港、装货地"
              >
                <el-option
                  v-for="item in portList"
                  :key="item.id"
                  :label="item.port"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="mjdmdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>

              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi('mjdm')">重置</el-button>
                <el-button class="shaixuan" @click="mjdmSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="mjdmTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="query_number" label="查询编号">
              </el-table-column>
              <el-table-column prop="type_desc" label="查询类型">
              </el-table-column>
              <el-table-column prop="country_name" label="国家">
              </el-table-column>
              <el-table-column prop="port_name" label="卸货港/卸货地">
              </el-table-column>
              <el-table-column prop="end_city_name" label="送达城市(邮编)">
              </el-table-column>
              <el-table-column prop="distance" label="卡车里程">
              </el-table-column>
              <el-table-column prop="price" label="拖车费合计">
                <template slot-scope="scope">
                  ${{scope.row.price}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="查询时间">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="mjdmForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="mjdmForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="mjdmTotal"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <Bottom />
  </div>
</template>
    
<script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import {
  basePortValidList,
  destinationPortRouteTypeValidList,
  getPortByCountries,
  getCityList,
  // getPortByCityId,
  mjdmmyRecordsLists,
  myRecordsLists,
} from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      activeName: "first",
      form: {
        num: "",
        status: "",
        date: "",
        qi: "",
        mu: "",
      },
      headers: {
        token: localStorage.getItem("token"),
      },
      // 起运港列表
      qiYGTitleList: [],
      muDgList: [],
      mdgloading:false,
      mdgActiveName: "",
      currentPage: 1,
      jxycTableData: [],
      jxycTotal: 0,
      jxycForm: {
        type: 1,
        page_no: 1,
        page_size: 10,
        query_number: "",
        state_port_id: "",
        end_port_id: "",
        state_time: "",
        end_time: "",
      },
      jxycdate: "",
      xcscTableData: [],
      xcscTotal: 0,
      xcscForm: {
        type: 2,
        page_no: 1,
        page_size: 10,
        query_number: "",
        state_port_id: "",
        end_port_id: "",
        state_time: "",
        end_time: "",
      },
      xcscdate: "",
      cdTableData: [],
      cdTotal: 0,
      cdForm: {
        type: 3,
        page_no: 1,
        page_size: 10,
        query_number: "",
        order_status: "",
        state_port_id: "",
        end_port_id: "",
        state_time: "",
        end_time: "",
      },
      cddate:'',
      mjdmTableData: [],
      mjdmTotal: 0,
      mjdmForm: {
        type:'1', // 进出口：1出口、2进口
        query_number:'',
        country_id:'', // 国家id
        state_port_id:'', // 起运港ID | 卸货港ID
        end_city_id:'',  // 送达城市ID | 起运城市ID
        port_id:'', // 卸货港、卸货地ID | 装货港、装货地ID
        state_time:'',
        end_time:'',
        status:'',
        page_no: 1,
        page_size: 10,
      },
      mjdmdate:'',
        statePortList:[], //美加到门起运港
        endPortList:[], // 美加到门送达城市
        portList:[], // 美加到门卸货港卸货地
      // 国家
      countryList: [
        {
          "id": 6,
          "name": "美国"
        },
        {
          "id": 7,
          "name": "加拿大"
        }
      ],
      loading:false,
      tableLoading:false,
    };
  },
  methods: {
    handleClick() {
      // this.mdgActiveName = this.muDgList[0].route_name;
      this.getMdgList()
      if (this.activeName == "first") {
        this.getJxyjList();
      } else if (this.activeName == "second") {
        this.getXcscList();
      } else if (this.activeName == "third") {
        this.getCdList();
      } else if (this.activeName == "fourth") {
        this.getMjdmList();
        this.getfujinPort()
      }
    },
    handleSizeChange(val) {
      if (this.activeName == "first") {
        this.jxycForm.page_size=val
        this.getJxyjList();
      } else if (this.activeName == "second") {
        this.xcscForm.page_size=val
        this.getXcscList();
      } else if (this.activeName == "third") {
        this.cdForm.page_size=val
        this.getCdList()
      } else if (this.activeName == "fourth") {
        this.mjdmForm.page_size=val
        this.getMjdmList();
      }
    },
    handleCurrentChange(val) {
        if (this.activeName == "first") {
        this.jxycForm.page_no=val
        this.getJxyjList();
      } else if (this.activeName == "second") {
        this.xcscForm.page_no=val
        this.getXcscList();
      } else if (this.activeName == "third") {
        this.cdForm.page_no=val
        this.getCdList()
      } else if (this.activeName == "fourth") {
        this.mjdmForm.page_no=val
        this.getMjdmList();
      }
    },
    async getMjdmList() {
      this.tableLoading = true
      try {
        const res = await mjdmmyRecordsLists(this.mjdmForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.mjdmTableData = res.data.lists;
          this.mjdmTotal = res.data.count;

          
          if(this.mjdmForm.country_id == ''){
            this.mjdmForm.country_id = '6'
          }
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    async getJxyjList() {
      this.tableLoading = true
      try {
        const res = await myRecordsLists(this.jxycForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.jxycTableData = res.data.lists;
          this.jxycTotal = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    async getXcscList() {
      this.tableLoading = true
      try {
        const res = await myRecordsLists(this.xcscForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.xcscTableData = res.data.lists;
          this.xcscTotal = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    async getCdList() {
      this.tableLoading = true
      try {
        const res = await myRecordsLists(this.cdForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.cdTableData = res.data.lists;
          this.cdTotal = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 起运港
    async getQygList() {
      // 起运港列表
      let basePortParams = {
        page_no: 1,
        page_size: 50,
        keyword: "",
      };
      const basePortRes = await basePortValidList(basePortParams);
      if (basePortRes.code == 1) {
        this.qiYGTitleList = basePortRes.data.lists;
      }
    },
    // 目的港
     async getMdgList(e) {
        this.mdgloading = true;
        if(e==undefined){
          e=''
        }
        // 目的港列表
        const res = await destinationPortRouteTypeValidList({
            keyword:e
          });
        if (res.code==1) {
          this.muDgList=res.data
          if(res.data.length>0){
            this.mdgActiveName=res.data[0].route_name
          }
          this.mdgloading = false
          // mdgloading:false,
        }
      },
      mdgremoteMethod(query){
        if (query !== '') {
          setTimeout(async () => {
            this.getMdgList(query)
          }, 200);
        } else {
          this.getMdgList();
        }
      },
    // 筛选
    jxycSearch() {
      this.jxycForm.state_time = this.jxycdate[0];
      this.jxycForm.end_time = this.jxycdate[1];
      this.getJxyjList();
    },
    xcscSearch() {
      this.xcscForm.state_time = this.xcscdate[0];
      this.xcscForm.end_time = this.xcscdate[1];
      this.getXcscList();
    },
    mjdmSearch() {
      this.mjdmForm.state_time = this.mjdmdate[0];
      this.mjdmForm.end_time = this.mjdmdate[1];
      this.getMjdmList();
    },
    cdSearch() {
      this.cdForm.state_time = this.cddate[0];
      this.cdForm.end_time = this.cddate[1];
      this.getCdList();
    },
    chongzhi(e){
      if (e == "jxyj") {
        this.jxycForm= {
          type: 1,
          page_no: 1,
          page_size: 10,
          query_number: "",
          pol_id: "",
          pod_id: "",
          state_time: "",
          end_time: "",
        }
        this.getJxyjList();
      } else if (e == "xcsc") {
        this.xcscForm= {
          type: 2,
          page_no: 1,
          page_size: 10,
          query_number: "",
          pol_id: "",
          pod_id: "",
          state_time: "",
          end_time: "",
        }
        this.getXcscList();
      } else if (e == "cd") {
        this.cdForm= {
          type: 3,
          page_no: 1,
          page_size: 10,
          query_number: "",
          order_status: "",
          pol_id: "",
          pod_id: "",
          state_time: "",
          end_time: "",
        }
        this.getCdList();
      } else if (e == "mjdm") {
        this.mjdmForm= {
          type:'1', // 进出口：1出口、2进口
          query_number:'',
          country_id:'', // 国家id
          state_port_id:'', // 起运港ID | 卸货港ID
          end_city_id:'',  // 送达城市ID | 起运城市ID
          port_id:'', // 卸货港、卸货地ID | 装货港、装货地ID
          state_time:'',
          end_time:'',
          status:'',
          page_no: 1,
          page_size: 10,
        }
        this.getMjdmList();
      }
    },
    // 美加到门  起运港
    async getPortList() {
      let params = {
        page_no: 1,
        page_size: 10,
        countries_id: this.mjdmForm.country_id,
      };
      const res = await getPortByCountries(params);
      if (res.code == 1) {
        this.statePortList = res.data.lists;
      }
    },
    qiehuan(){
      this.mjdmForm.end_city_id = ''
      this.mjdmForm.port_id = ''
      // this.zipCodeRemoteMethod()
      this.endPortList = []
      this.getfujinPort()
    },
    // 美加到门 城市邮编
    async getZipCodeList() {
      try {
        // if(this.mjdmForm.end_city_id!=''){
        let params = {
          page_no: 1,
          page_size: 10,
          countries_id: this.mjdmForm.country_id,
          keyword: this.mjdmForm.end_city_id,
        };
        const res = await getCityList(params);
        if (res.code == 1) {
          this.endPortList = res.data.lists;
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 城市邮编 远程搜索
    zipCodeRemoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.mjdmForm.end_city_id = query
          this.getZipCodeList();
        }, 200);
      } else {
        this.endPortList = [];
      }
    },
    // 获取附近港口
    async getfujinPort() {
      this.mjdmForm.port_id = "";
      let params = {
        page_no: 1,
        page_size: 60,
        countries_id: this.mjdmForm.country_id || 6,
      };
      const res = await getPortByCountries(params);
      if (res.code == 1) {
        this.portList = res.data.lists;
      }
    },
  },
  mounted() {
    this.getJxyjList();
    this.getQygList();
    this.getMdgList();
  },
};
</script>
    
<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.content {
  border-radius: 12px 12px 12px 12px;
  background: #fff;

  margin-bottom: 32px;

  padding: 32px;

  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 10px;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #0073f5; //选中
  }

  ::v-deep .el-tabs__item:hover {
    color: #0073f5; //hover
    // cursor: pointer;
  }
  // 普通字体颜色
  ::v-deep .el-tabs__item {
    color: #606260; //悬浮
    // cursor: pointer;
    font-size: 18px;
  }

  // 下划线颜色
  ::v-deep .el-tabs__active-bar {
    background-color: #0073f5;
  }

  .yi {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    margin-top: 4px;

    .btns {
      width: 360px;
      height: 40px;
      text-align: right;

      .chongzhi {
        width: 100px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        font-style: normal;
        text-transform: none;
      }

      .shaixuan {
        width: 100px;
        height: 40px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
        font-style: normal;
        text-transform: none;
      }
    }

    :deep(.el-input) {
      width: 360px;
      height: 40px;
      margin-bottom: 16px;

      input {
        width: 360px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;

        border: 0;
      }
    }
    :deep(.el-date-editor) {
      width: 360px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      margin-bottom: 16px;

      .el-range-input {
        background: #f9f9f9;
      }
    }
  }


  .el-pagination {
    text-align: right;
    margin-top: 80px;
  }
}

.mudig {
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  width: 500px;
  .mdglist {
    :deep(.el-select-group) {
      display: flex;
      flex-wrap: wrap;
    }
  }
  :deep(.el-select) {
    ul.el-select-group {
      display: flex;
    }
  }
}
</style>